module.exports = __webpack_public_path__ + "static/media/rule_th.24f8410a.png";